import { FC } from 'react'
import styles from './CardStore.module.scss'
import { useTranslation } from 'next-i18next'

//component
import AppStoreButtonComponent from 'components/buttons/AppStoreButtonComponent'
import GooglePlayButtonComponent from 'components/buttons/GooglePlayButtonComponent'

const CardStore: FC = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.card}>
      <div className={styles.cardInfo}>
        <div className={styles.cardTitle}>{t('AREAS.APP.DOWNLOAD_COMFORTABLE')}</div>
        <div className={styles.cardBanner}>
          <AppStoreButtonComponent />
          <GooglePlayButtonComponent />
        </div>
      </div>
      <div>
        <img
          className={styles.cardImage}
          src="/app_main_visual.webp"
          alt={t('META.APP_MAIN_VISUAL')}
        />
      </div>
    </div>
  )
}

export default CardStore
